<template>
  <v-navigation-drawer
    v-model="drawer"
    :permanent="!isMobile"
    :temporary="isMobile"
    :rail="!isMobile && rail"
    color="sidebar"
    @click="!isMobile && (rail = false)"
  >
    <v-list density="compact" nav>
      <v-list-item>
        <v-list-item-content>
          <v-img
            :src="logoSrc"
            alt="Logo"
            max-width="150"
            class="logo"
          />
        </v-list-item-content>

        <!-- Solo mostrar botón toggle en modo escritorio -->
        <template v-if="!isMobile" v-slot:append>
          <v-btn
            style="font-size:20px; margin-left:-5px;"
            :icon="toggleIcon"
            variant="text"
            @click.stop="rail = !rail"
          >
            <v-icon>{{ toggleIcon }}</v-icon>
          </v-btn>
        </template>
      </v-list-item>

      <v-list-item
        v-for="menu in sortedMenus"
        :key="menu.id"
        :prepend-icon="menu.icon"
        :to="menu.href"
        exact
        @click="handleItemClick"
      >
        <v-list-item-content>
          <v-list-item-title>{{ menu.title }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    
    <transition name="fade-slide">
      <div v-if="!isMobile && !rail" class="logo-container">
        <img :src="'/files/clienTOR-' + $vuetify.theme.name + '.svg'" width="60px" />
        <span class="version ml-1">v2.0.0</span>
      </div>
    </transition>
    <transition name="fade-slide">
      <div class="position-absolute bottom-0 my-6 ml-2" v-if="rail">
        <img :src="'/files/isotipo-' + $vuetify.theme.name + '.svg'" width="12px" class="mx-3"/>
        <span style="font-size:11px;">v2.0.0</span>
      </div>
    </transition>
    
  </v-navigation-drawer>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useDisplay, useTheme } from 'vuetify';
import { useUiStore } from '@/store/ui';
import { apiClient } from '@/plugins/axios';

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const theme = useTheme();
const uiStore = useUiStore();
const drawer = computed({
  get: () => uiStore.drawer,
  set: (val) => (uiStore.drawer = val),
});

const rail = ref(true);
const menus = ref([]);

const logoSrc = computed(() =>
  theme.global.current.value.dark
    ? require('@/assets/logo-white.png')
    : require('@/assets/logo-black.png')
);

const toggleIcon = computed(() => (rail.value ? 'mdi-menu-close' : 'mdi-menu-open'));
const sortedMenus = computed(() => menus.value.sort((a, b) => a.order - b.order));

// 👉 cierra el drawer en móvil al navegar
const handleItemClick = () => {
  if (isMobile.value) {
    drawer.value = false;
  }
};

const fetchMenus = async () => {
  try {
    const res = await apiClient.get('/menu');
    menus.value = res.data;
  } catch (err) {
    console.error('Error loading menu:', err);
  }
};

// 🔧 Si estamos en escritorio, forzar que el drawer esté abierto al inicio
onMounted(() => {
  if (!isMobile.value) {
    uiStore.drawer = true;
  }
});

fetchMenus();
</script>

<style scoped>
.v-navigation-drawer--left {
  border-right-width: 0; /* Remove right border */
}

::v-deep(.v-icon--size-default) {
  font-size: 1em; /* Adjust as needed */
}

::v-deep(.v-list-item__prepend) {
  display: block;
  text-align: center;
}

.v-list-item-title {
  margin-top: 3px;
}

.v-navigation-drawer .v-list {
  padding-right: 0px;
}

.logo {
  margin-bottom: 20px;
  margin-top: 10px;
  width: 60px;
}

/* Position the hamburger icon at the top right */
.toggle-menu-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1; /* Ensure it appears above other content */
}

.logo-container {
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 6px; /* espacio entre logo y versión */
  white-space: nowrap; /* 👈 importante: evita salto de línea */
}

.version {
  font-size: 10px;
  margin-top: 7px;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
}
</style>
